module.exports = __webpack_public_path__ + "e0106718/img/verified-icon.f93bbc14.svg";